<ng-container *ngIf="data$ | async"></ng-container>

<div mat-dialog-title>
  <span i18n class="title dialog-title">Панели со склада</span>
  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="no-padding h-96" [cslOverlayLoader]="loading$">
  <table mat-table [dataSource]="data$" class="w-full">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="length">
      <th mat-header-cell *matHeaderCellDef i18n>Длина (мм)</th>
      <td mat-cell *matCellDef="let element">{{ element.length }}</td>
    </ng-container>

    <ng-container matColumnDef="width">
      <th mat-header-cell *matHeaderCellDef i18n>Ширина (мм)</th>
      <td mat-cell *matCellDef="let element">{{ element.width }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<div mat-dialog-actions>
  <button
    i18n
    type="button"
    mat-raised-button
    class="mat-accent"
    [mat-dialog-close]="selection.selected[0]"
    [disabled]="!selection.selected.length"
    >ОК</button
  >
  <button i18n type="button" mat-button [mat-dialog-close]>ОТМЕНА</button>
</div>
